import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  setCurrentStep,
  setSelectedActionType,
  setSubscriberSendFormType,
  setSubscriberPersonalData,
  setSubscriberAddress,
  setCurrentPopUp,
} from '../OwnershipTransferSlice';
import SelectOptionExtendedButton from '../../../Shared/SelectOptionExtendedButton/SelectOptionExtendedButton';
import TextInput from '../../../Shared/TextInput/TextInput';
import {
  OwnershipTransferStep,
  FormSendType,
  OwnershipTransferActionType,
  PopupMessageContent,
  FutureBusinessAccountType,
  PopupEnum,
} from '../Constant/Constant';
import { validateInput, TextInputEnum } from '../../../../utilities/validation/InputValidation';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import AddressForm from '../../SaleJetBlock/Partials/AddressForm/AddressForm';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const CustomerForm = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.LineOwnerDetailPage,
        messageText: DWHMessageText.LineOwnerDetailPageDisplayed,
        status: DWHStatus.Ongoing,

      });
    }
  }, []);

  const [errors, setErrors] = useState({ firstName: '', lastName: '', idNumber: '', sms: '', email: '' });
  const [isSubmit, setIsSubmit] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [submitForm, setSubmitForm] = useState(false);
  const selected_phone = props.data.selectedPhoneNumber?.replace(/^(.{3})(.*)$/, '$1-$2');
  const numberRegex = /^\d+$/;
  const [buttons, setButtons] = useState([
    {
      id: '0',
      label: 'SMS',
      value: FormSendType.sms,
      selected: props.data.subscriberSendFormType.type === FormSendType.sms ? true : false,
      textInputValidationType: TextInputEnum.Phone,
      onChange: inputChangeHandler,
      inputValue: props.data.selectedPhoneNumber,
      pattern: '[0-9]*',
      maxLength: '10'
    },
    {
      id: '1',
      label: 'מייל',
      value: FormSendType.email,
      selected: props.data.subscriberSendFormType.type === FormSendType.email ? true : false,
      textInputValidationType: TextInputEnum.Mail,
      onChange: inputChangeHandler,
      inputValue: props.data.subscriberSendFormType.type === FormSendType.email ? props.data.subscriberSendFormType.email : '',
    },
  ]);

  useEffect(() => {
    if (submitForm) {
      props.submitRequest();
    }
  }, [submitForm]);

  function inputChangeHandler(type, value, error) {

    if (type === FormSendType.sms && value && !numberRegex.test(value)) { return null; }

    setButtons((buttonsData) => buttonsData.map((btn) => (btn.value === type ? { ...btn, inputValue: value } : btn)));
    setErrors({ ...errors, [type]: error });
    setShowErrorMsg(false);
  }

  function manageData(value) {
    let newButtonData = buttons.map((button) => {
      if (button.value === value) {
        button.selected = true;
      } else {
        button.selected = false;
      }
      return button;
    });
    setButtons(newButtonData);
  }

  async function setCustomerAddress(res) {
    const address = {
      city: res.selectedAddress.cityName,
      street: res.selectedAddress.streetName,
      houseNum: res.selectedAddress.home,
      zipCode: res.selectedAddress.zipCode,
    };
    await props.setSubscriberAddress(address);

    if (Object.values(address).some((value) => !value)) {
      setShowErrorMsg(true);
    } else {
      setShowErrorMsg(false);
      nextStep();
    }
    setIsSubmit(false);
  }

  function nextStep() {
    if (!validateRequiredData()) {
      setShowErrorMsg(true);
    } else {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.LineOwnerDetailPage,
        messageText: DWHMessageText.LineOwnerDetailPageButtonClicked,
        status: DWHStatus.Ongoing,
      });
      setShowErrorMsg(false);

      if (props.data.selectedActionType == OwnershipTransferActionType.FullFundingToSeparate) {
        setSubmitForm(true);
      } else {
        props.setCurrentStep(OwnershipTransferStep.ContactPersonForm);
      }
    }
  }
  function validateRequiredData() {
    let selectedFormSendType = buttons.find((button) => button.selected);

    if (
      !selectedFormSendType ||
      errors[selectedFormSendType.value] !== '' ||
      Object.values(props.data.subscriberPersonalData).some((value) => !value || value.trim() === '') ||
      selectedFormSendType.inputValue.trim() === ''
    ) {
      return false;
    } else {
      if (
        props.data.selectedActionType == OwnershipTransferActionType.PrivateToBusiness &&
        props.data.subscriberPersonalData.idNumber != props.data.customerIdNumber
      ) {
        {
          props.setCurrentPopUp({ currentPopUp: PopupEnum.CustomerValidationResult, currentPopupData: PopupMessageContent.IdNumberError });
          return false;
        }
      }
      props.setSubscriberSendFormType({ type: selectedFormSendType.value, value: selectedFormSendType.inputValue });
      return true;
    }
  }

  return (
    <div className='ownership-transfer-form stepContainer customer-form  ownership-transfer-step'>
      {/* <div className='stepContainer'> */}
      <div className='l-title center'>פרטי מנוי מספר {selected_phone}</div>
      <div className='m-title center'> הפרטים שימולאו מטה יוצגו אוטומטית בטופס לחתימה שישלח למנוי</div>
      <div className='customer-data'>
        {(props.data.selectedActionType == OwnershipTransferActionType.FullFundingToSeparate ||
          (props.data.selectedActionType == OwnershipTransferActionType.PrivateToBusiness &&
            props.data.futureAccountType == FutureBusinessAccountType.BusinessSplit)) && (<div className='m-title semi mb-8'>פרטים אישיים</div>)}

        <TextInput
          value={props.data.subscriberPersonalData.firstName}
          error={errors.firstName}
          id='firstName'
          placeholder={'שם פרטי'}
          onChange={(e) => {
            setErrors({ ...errors, firstName: validateInput(e.target.value, TextInputEnum.FirstName) });
            props.setSubscriberPersonalData({ firstName: e.target.value });
            setShowErrorMsg(false);
          }}
          required='required'
        />
        <TextInput
          value={props.data.subscriberPersonalData.lastName}
          error={errors.lastName}
          id='lastName'
          placeholder={'שם משפחה'}
          onChange={(e) => {
            setErrors({ ...errors, lastName: validateInput(e.target.value, TextInputEnum.LastName) });
            props.setSubscriberPersonalData({ lastName: e.target.value });
            setShowErrorMsg(false);
          }}
          required='required'
        />
        <TextInput
          value={props.data.subscriberPersonalData.idNumber}
          error={errors.idNumber}
          id='idNumber'
          placeholder={'ת.ז'}
          pattern='[0-9]*'
          maxLength='9'
          onChange={(e) => {
            if (numberRegex.test(e.target.value) || e.target.value === '') {
              setErrors({ ...errors, idNumber: validateInput(e.target.value, TextInputEnum.Id) });
              props.setSubscriberPersonalData({ idNumber: e.target.value });
              setShowErrorMsg(false);
            }
          }}
          required='required'
          disabled={
            props.data.selectedActionType == OwnershipTransferActionType.BusinessToPrivate && props.data.customerAccountType == 'BusinessSplit'
          }
        />
      </div>
      {(props.data.selectedActionType == OwnershipTransferActionType.FullFundingToSeparate ||
        (props.data.selectedActionType == OwnershipTransferActionType.PrivateToBusiness &&
          props.data.futureAccountType == FutureBusinessAccountType.BusinessSplit)) && (
          <div>
            <div className='m-title semi mb-8'>כתובת המנוי</div>
            <AddressForm
              withoutApartmentData={true}
              isSubmit={isSubmit}
              onSubmit={(res) => setCustomerAddress(res)}
              selectedAddress={{
                cityName: props.data.subscriberPersonalData?.city ?? '',
                streetName: props.data.subscriberPersonalData?.street ?? '',
                home: props.data.subscriberPersonalData?.houseNum ?? '',
                apartment: props.data.subscriberPersonalData?.apartment ?? '',
              }}
            />
          </div>
        )}
      <div>
        <SelectOptionExtendedButton title={'לאן לשלוח למנוי את הטופס לחתימה?'} buttonsData={buttons} onClick={manageData} />
      </div>
      <div className='continue-button'>
        {showErrorMsg && <div className='error center'>כדי להמשיך יש למלא את כל שדות החובה</div>}
        <BtnSubmit
          onclick={
            props.data.selectedActionType == OwnershipTransferActionType.FullFundingToSeparate ||
              (props.data.selectedActionType == OwnershipTransferActionType.PrivateToBusiness &&
                props.data.futureAccountType == FutureBusinessAccountType.BusinessSplit)
              ? () => setIsSubmit(true)
              : nextStep
          }
          text={
            props.data.selectedActionType == OwnershipTransferActionType.FullFundingToSeparate
              ? 'אישור ושליחת טפסים לחתימה'
              : 'אישור ומעבר לפרטי איש קשר'
          }
        />
      </div>
      {/* </div> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedActionType,
  setSubscriberSendFormType,
  setSubscriberPersonalData,
  setSubscriberAddress,
  setCurrentPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerForm);
